(() => {
  const header = document.querySelector('[data-opsin-header]');
  if (!header) return;

  // The drawer and backdrop are siblings of the header (see opsin-header.liquid
  // for why), so they are queried at document level, not inside the header.
  const openButton = header.querySelector('[data-opsin-menu-open]');
  const menu = document.querySelector('[data-opsin-mobile-menu]');
  const backdrop = document.querySelector('[data-opsin-menu-backdrop]');
  const closeButton = menu ? menu.querySelector('[data-opsin-menu-close]') : null;
  let previousFocus = null;

  if (!openButton || !menu) return;

  const focusable = () => Array.from(menu.querySelectorAll('a[href], button:not([disabled])'));

  const closeMenu = () => {
    menu.hidden = true;
    if (backdrop) backdrop.hidden = true;
    document.body.classList.remove('opsin-menu-open');
    openButton.setAttribute('aria-expanded', 'false');
    if (previousFocus) previousFocus.focus();
  };

  const openMenu = () => {
    previousFocus = document.activeElement;
    menu.hidden = false;
    if (backdrop) backdrop.hidden = false;
    document.body.classList.add('opsin-menu-open');
    openButton.setAttribute('aria-expanded', 'true');
    const items = focusable();
    if (items.length) items[0].focus();
  };

  openButton.addEventListener('click', openMenu);
  if (closeButton) closeButton.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);

  document.addEventListener('keydown', (event) => {
    if (menu.hidden) return;
    if (event.key === 'Escape') closeMenu();
    if (event.key !== 'Tab') return;
    const items = focusable();
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

/* Homepage review carousel controls (P4, 2026-08-30): the review grid is a
   CSS scroll-snap carousel below 768px (see opsin-fixes.css). This adds real
   prev/next buttons and a "1 / 3" position indicator. Injected only when the
   carousel layout is active; swipe alone works without it. No autoplay. */
(() => {
  const grid = document.querySelector('.opsin-proof__grid');
  if (!grid) return;
  const cards = Array.from(grid.querySelectorAll('.opsin-review-card'));
  if (cards.length < 2) return;
  const mq = window.matchMedia('(max-width: 767.98px)');

  let nav = null;
  const build = () => {
    if (nav || !mq.matches) return;
    nav = document.createElement('div');
    nav.className = 'opsin-proof__carousel-nav';
    const prev = document.createElement('button');
    prev.type = 'button';
    prev.setAttribute('aria-label', 'Previous review');
    prev.textContent = '←';
    const count = document.createElement('span');
    count.className = 'opsin-proof__carousel-count';
    count.setAttribute('aria-live', 'polite');
    const next = document.createElement('button');
    next.type = 'button';
    next.setAttribute('aria-label', 'Next review');
    next.textContent = '→';
    nav.append(prev, count, next);
    grid.after(nav);

    const current = () => {
      const mid = grid.scrollLeft + grid.clientWidth / 2;
      let best = 0;
      let bestDist = Infinity;
      cards.forEach((c, i) => {
        const center = c.offsetLeft + c.offsetWidth / 2;
        const d = Math.abs(center - mid);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    };
    const update = () => { count.textContent = (current() + 1) + ' / ' + cards.length; };
    const goTo = (i) => {
      const c = cards[Math.max(0, Math.min(cards.length - 1, i))];
      grid.scrollTo({ left: c.offsetLeft - (grid.clientWidth - c.offsetWidth) / 2 });
    };
    prev.addEventListener('click', () => goTo(current() - 1));
    next.addEventListener('click', () => goTo(current() + 1));
    grid.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    update();
  };
  build();
  mq.addEventListener('change', () => { if (mq.matches) build(); else if (nav) { nav.remove(); nav = null; } });
})();

/* Big Game sticky-bar activation (2026-08-30): the Big Game section's own
   mobile sticky bar previously showed at page load. Apply the same rule as
   the standard PDP bar — hidden until the buy module has been seen AND
   scrolled past, hidden again when the shopper returns to it. Pairs with
   the .is-active gate in opsin-fixes.css. Fail-safe: without
   IntersectionObserver the bar never shows. */
(() => {
  const section = document.querySelector('.opsin-big-game');
  if (!section || !('IntersectionObserver' in window)) return;
  const stickyBar = section.querySelector('[data-opsin-sticky]');
  const buyModule = section.querySelector('.opsin-buy');
  if (!stickyBar || !buyModule) return;

  let seenBuy = false;
  let pastBuy = false;
  const io = new IntersectionObserver((entries) => {
    const entry = entries[0];
    if (entry.isIntersecting) {
      seenBuy = true;
      pastBuy = false;
    } else if (seenBuy) {
      pastBuy = entry.boundingClientRect.bottom < 0;
    }
    stickyBar.classList.toggle('is-active', seenBuy && pastBuy);
  }, { threshold: 0 });
  io.observe(buyModule);
})();
